module.exports = __webpack_public_path__ + "static/media/samsung-aife-2021-display-performance.27a8263c.mp4";